<template>
  <header>
    <router-link class="brand" to="/" :aria-label="`VERVESTEEL ${$t('common.home')}`" @click.native="closeMenu">
      <img src="/assets/logo.webp" alt="VERVESTEEL">
      <span>VERVESTEEL<small>VALUE THROUGH STRENGTH</small></span>
    </router-link>
    <nav id="navigation" :class="{ open: menuOpen }" aria-label="Navigation">
      <router-link v-for="item in nav" :key="item.path" :to="item.path" exact @click.native="closeMenu">{{ item.label }}</router-link>
    </nav>
    <router-link class="header-cta" to="/contact">{{ $t('common.consult') }} ↗</router-link>
    <div class="language-control">
      <button class="language-toggle" type="button" :aria-label="$t('language.title')" :aria-expanded="String(languageOpen)" @click="openLanguage">
        <span class="language-mark" aria-hidden="true">◎</span>
        <span class="language-name">{{ currentLanguage.native }}</span>
        <span class="language-arrow" aria-hidden="true"></span>
      </button>
    </div>
    <button class="menu-toggle" type="button" :aria-expanded="String(menuOpen)" aria-controls="navigation" :aria-label="$t('header.menu')" @click="menuOpen = !menuOpen">☰</button>
    <LanguageDialog ref="languageDialog" @close="languageOpen = false" />
  </header>
</template>

<script>
import LanguageDialog from './LanguageDialog.vue'
import { supportedLocales } from '../i18n'

export default {
  name: 'SiteHeader',
  components: { LanguageDialog },
  data() {
    return {
      menuOpen: false,
      languageOpen: false
    }
  },
  computed: {
    currentLanguage() { return supportedLocales.find(item => item.code === this.$i18n.locale) || supportedLocales[0] },
    nav() {
      return [
        { label: this.$t('common.home'), path: '/' }, { label: this.$t('common.about'), path: '/about' },
        { label: this.$t('common.solutions'), path: '/solutions' }, { label: this.$t('common.products'), path: '/products' },
        { label: this.$t('common.cases'), path: '/cases' }, { label: this.$t('common.service'), path: '/service' },
        { label: this.$t('common.resources'), path: '/resources' }
      ]
    }
  },
  methods: {
    closeMenu() { this.menuOpen = false },
    openLanguage() {
      this.languageOpen = true
      this.$refs.languageDialog.open()
    }
  }
}
</script>
